import React, { useEffect, useRef, useState } from "react";
import {
    Button, Table, Overlay,
    Popover, Col, Form, Row
} from "react-bootstrap";
import Loader from "../../../Loader/Loader";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import moment from "moment";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import Comments from "../Comments/Comment";
import SingleDateSummaryModal from "../../SingleDateSummaryModal";
import SingleDayGroupModal from "../../SingleDayGroupModal";
import { FixColumn } from "../../../../utils/dataTable";
import emailIcon from "../../../../Assets/Images/Email.svg";



export const LowDemandDates = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {

    const { snapshottitle, propertyCode, snapshotId } = useParams();

    const propertyDetailFromRTK = useSelector((store) => store.headerProperty.propertyDetail);

    const defaultAsOfDateFromRTK = useSelector((store) => store.headerProperty.defaultAsOfDate);

    const [tblids, settblids] = useState({
        lowDemandTable: commonService.GenerateGUID(),
    });

    const widgetDetailRef = useRef();

    const [widgetModal, setWidgetModal] = useState(false);

    const closeWidgetModal = () => {
        setWidgetModal(false);
    };
    const handleOtbClick = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setOtbModal({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };
    const asOfDateFromRTK = useSelector((store) => store.headerProperty.asOfDate);
    const sevenDayPickupRef = useRef();

    const [lowDemandLoading, setLowDemandLoading] = useState(false);
    const [lowDemandData, setLowDemandData] = useState(null);
    const singleDateTypeRef = useRef();
    const singleDateSelectedDateRef = useRef();
    const selectedTdIndexRef = useRef();
    const [ONTHEBOOKS, setONTHEBOOKS] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });
    const [otbModal, setOtbModal] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });
    const handleFilterBtnClick = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setONTHEBOOKS({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };
    const [showSingleDateSummaryModal, setShowSingleDateSummaryModal] =
        useState(false);
    const closeSingleDateSummaryModal = () => {
        setShowSingleDateSummaryModal(false);
    };
    const closeSingleDate = () => {
        selectedTdIndexRef.current = -1;
        setONTHEBOOKS({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };
    const closeOtbClick = () => {
        selectedTdIndexRef.current = -1;
        setOtbModal({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };

    const getLowDemandDates = async () => {
        setLowDemandLoading(true);
        let lowDemandDatesResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.REVENUE_GLANCE.LOW_DEMAND_DATES,
                body: {
                    propertyCode: propertyCode,
                    asofdate: asOfDateFromRTK || defaultAsOfDateFromRTK || "",
                },
            },
            false
        );

        let response = apiResponse(false, lowDemandDatesResponse);

        if (response?.isValidate) {
            setLowDemandData(response?.data?.data);
            setLowDemandLoading(false);
        }

        if (!response?.isValidate) {
            setLowDemandData(null);
            setLowDemandLoading(false);
        }
    };
    FixColumn(tblids.lowDemandTable, [1]);

    useEffect(() => {
        if (api === 0) {

        } else {
            getLowDemandDates();
        }
    }, [para?.propertyCode]);

    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.lowDemandTable} .perbackground-otb`
    );
    commonService.setBackColorPerByTDValue(
        "Green",
        "Red",
        `#${tblids.lowDemandTable} .perbackground-adr`
    );
    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.lowDemandTable} .perbackground-room`
    );
    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.lowDemandTable} .perbackground-1room`
    );
    commonService.setBackColorPerByTDValue(
        "#FFC140",
        "Red",
        `#${tblids.lowDemandTable} .perbackground-GroupOTB`
    );

    return (
        <div className="widget-container" style={{position: "relative"}}>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    <Button
                        className="heading-menu-btns"
                        type="button"
                        title="Send Mail"
                    >
                        <img id={commonService.generateGlobalClickTrackerID("LowDemandDates", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.lowDemandTable,
                                    "LowDemandDates",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("LowDemandDates", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.LowDemandDates,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("LowDemandDates", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={tblids.lowDemandTable}
                            onClick={() =>
                                commonService.fnExportInCSV(
                                    tblids.lowDemandTable,
                                    `${para?.propertyCode}-LowDemandDates-${moment(
                                        new Date()
                                    ).format("MMDDYYYY")}`
                                )
                            }
                        />
                    </Button>
                    
                </div>
            )}
            <Row>
                <Col xl={12}>
                    <div className="ViewPropertySetupTable">
                        <div className="stripped__table">
                            <Table id={tblids?.lowDemandTable} responsive>
                                <thead>
                                    <tr>
                                        <th className="text-center" colSpan={50}>
                                            Low Demand Dates
                                        </th>
                                    </tr>
                                    <tr>
                                        <th className="border_right" colSpan={7}></th>
                                        <th className="border_right text-center" colSpan={5}>
                                            TRANSIENT CURRENT YEAR
                                        </th>
                                        <th className="border_right text-center" colSpan={2}>
                                            Revenue
                                        </th>
                                        <th className="border_right text-center">Group</th>
                                        <th className="border_right text-center" colSpan={2}>
                                            Bar Based Stats
                                        </th>
                                        <th className="border_right text-center" colSpan={3}>
                                            1 Day Pickup
                                        </th>
                                        <th className="border_right text-center" colSpan={3}>
                                            7 Day Pickup
                                        </th>
                                        <th className="text-center border_right" colSpan={3}>
                                            Pricing & Forecast
                                        </th>
                                        {lowDemandData?.[0]?.Rateshop && (
                                            <th
                                                colSpan={lowDemandData?.[0]?.Rateshop?.length + 1}
                                                className="text-center"
                                            >
                                                RateShop
                                            </th>
                                        )}
                                    </tr>
                                    <tr>
                                        <th className="border_right">Stay Date</th>
                                        <th className="border_right">Day Before Arrival</th>
                                        <th className="border_right">DOW</th>
                                        <th className="border_right text-center">Current Occ%</th>
                                        <th className="text-center border_right">
                                            Forecasted Occ%
                                        </th>
                                        <th className="text-end border_right">ADR</th>
                                        <th className="text-center border_right">
                                            {/* LY3 Quartile Leadtime */}
                                            LY Median Leadtime
                                        </th>
                                        <th className="width100">OOO\Rooms Available</th>
                                        <th className="width75 text-center">Left To sell</th>
                                        <th className="width75 text-center">On The Books</th>
                                        <th>Total OCC%</th>
                                        <th className="text-end border_right">ADR</th>
                                        <th className="text-end">Rev</th>
                                        <th className="text-end border_right">RevPAR</th>
                                        <th className="border_right">OTB\Block</th>
                                        <th className="width50 text-center">OTB</th>
                                        <th className="width100 text-center border_right">
                                            8 Week Rolling Avg
                                        </th>

                                        <th className="text-center">Rooms</th>
                                        <th className="text-end">ADR Change</th>
                                        <th className="text-end border_right">Rev</th>

                                        <th className="text-center">Rooms</th>
                                        <th className="text-end">ADR Change</th>
                                        <th className="text-end border_right">Rev</th>

                                        <th className="text-center width110">System Forecast</th>
                                        <th>R28 Avg</th>
                                        <th className="text-end border_right">Optimal Bar</th>
                                        {lowDemandData &&
                                            lowDemandData?.[0]?.Rateshop?.map((x) => {
                                                if (x.IsSelf === true) {
                                                    return (
                                                        <th
                                                            className="text-end border-right"
                                                            title={x?.competiterpropertyname}
                                                        >
                                                            {x?.competiterpropertyname?.length > 10
                                                                ? `${x?.competiterpropertyname?.slice(
                                                                    0,
                                                                    10
                                                                )}...`
                                                                : x?.competiterpropertyname}
                                                        </th>
                                                    );
                                                }
                                            })}
                                        {lowDemandData?.[0]?.Rateshop && (
                                            <th className="text-end">Avg Competitor</th>
                                        )}
                                        {lowDemandData &&
                                            lowDemandData?.[0]?.Rateshop?.map((x) => {
                                                if (x.IsSelf === false) {
                                                    return (
                                                        <th
                                                            className="text-end"
                                                            title={x?.competiterpropertyname}
                                                        >
                                                            {x?.competiterpropertyname?.length > 10
                                                                ? `${x?.competiterpropertyname?.slice(
                                                                    0,
                                                                    10
                                                                )}...`
                                                                : x?.competiterpropertyname}
                                                        </th>
                                                    );
                                                }
                                            })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {lowDemandLoading ? (
                                        <tr style={{ height: "80px", position: "relative" }}>
                                            <Loader />
                                        </tr>
                                    ) : lowDemandData?.length > 0 ? (
                                        lowDemandData?.map((item, index) => {
                                            let isSelfData = item?.Rateshop?.filter((x) => {
                                                if (x.IsSelf === true) {
                                                    return x;
                                                }
                                            });
                                            let rateShoptotal = 0;
                                            item?.Rateshop?.map((x) => {
                                                if (x.IsSelf === false) {
                                                    rateShoptotal = rateShoptotal + parseFloat(x?.Rate);
                                                }
                                            });
                                            let findCompetitorData = item?.Rateshop?.filter(
                                                (x) => x.IsSelf === false
                                            );

                                            let findDataForAvgCount = item?.Rateshop?.filter(
                                                (x) => x.IsSelf === false && parseFloat(x.Rate) > 0
                                            );

                                            let avgCompetitor =
                                                rateShoptotal > 0 && findCompetitorData?.length > 0
                                                    ? Math.round(
                                                        rateShoptotal / findDataForAvgCount?.length
                                                    )
                                                    : 0;

                                            let foreCastSpiderTextColor = "";
                                            let forecastSpiderBorder = "";
                                            if (item?.Forecast_RMS < item?.R28AVG) {
                                                foreCastSpiderTextColor = "redText";
                                                let R28AvgPercentage = (item?.R28AVG * 10) / 100;
                                                let finalValue = item?.R28AVG - R28AvgPercentage;
                                                if (item?.Forecast_RMS < finalValue) {
                                                    forecastSpiderBorder = "redBorderTd";
                                                }
                                            } else {
                                                let R28AvgPercentage = (item?.R28AVG * 10) / 100;
                                                let finalValue = item?.R28AVG + R28AvgPercentage;
                                                if (item?.Forecast_RMS > finalValue) {
                                                    forecastSpiderBorder = "blackBorderTd";
                                                }
                                            }

                                            return (
                                                <tr className="shadowOnHover">
                                                    <td className="border_right">
                                                        {item?.StayDate
                                                            ? commonService.getDateInFormat(item?.StayDate)
                                                            : ""}
                                                    </td>
                                                    <td className="border_right">
                                                        {item?.DaysBeforeArrival
                                                            ? item?.DaysBeforeArrival
                                                            : 0}
                                                    </td>
                                                    <td className="border_right">{item?.DayOfWeek}</td>
                                                    <td className="border_right text-center">
                                                        {item?.CurrentOccperc ? item?.CurrentOccperc : 0}%
                                                    </td>
                                                    <td className="text-center border_right">
                                                        {item?.ForecastedOccperc
                                                            ? item?.ForecastedOccperc
                                                            : 0}
                                                        %
                                                    </td>
                                                    <td className="text-end border_right">
                                                        {item?.ADR
                                                            ? commonService.formateAmount(
                                                                Math.round(item?.ADR)
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>
                                                    <td className="text-center border_right">
                                                        {item?.LY3QuartileLeadtime
                                                            ? item?.LY3QuartileLeadtime
                                                            : 0}
                                                    </td>
                                                    <td className="width100">
                                                        {item?.OnTheBook?.[0]?.OOO
                                                            ? item?.OnTheBook?.[0]?.OOO
                                                            : 0}
                                                        {"/"}
                                                        {item?.OnTheBook?.[0]?.RoomAvailable
                                                            ? item?.OnTheBook?.[0]?.RoomAvailable
                                                            : 0}
                                                    </td>
                                                    <td className="text-center">
                                                        {item?.OnTheBook?.[0]?.LeftToSell
                                                            ? commonService.formateRoom(
                                                                item?.OnTheBook?.[0]?.LeftToSell
                                                            )
                                                            : commonService.formateRoom(0)}
                                                    </td>
                                                    <td
                                                        className="text-primary text-center perbackground perbackground-otb"
                                                        value={
                                                            item?.OnTheBook?.[0]?.OnTheBook
                                                                ? item?.OnTheBook?.[0]?.OnTheBook
                                                                : 0
                                                        }
                                                    >
                                                        <span id={commonService.generateGlobalClickTrackerID("LowDemandDates", "low-demand-dates-transient-current", item)}
                                                            className={`${selectedTdIndexRef.current === index &&
                                                                singleDateTypeRef.current === "lowDemand"
                                                                ? "singleDateSummarySpan"
                                                                : ""
                                                                }`}
                                                            onClick={(e) => {
                                                                singleDateTypeRef.current = "lowDemand";
                                                                singleDateSelectedDateRef.current =
                                                                    item?.StayDate;
                                                                handleFilterBtnClick(e);
                                                                selectedTdIndexRef.current = index;
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            {item?.OnTheBook?.[0]?.OnTheBook
                                                                ? item?.OnTheBook?.[0]?.OnTheBook
                                                                : 0}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        {item?.OnTheBook?.[0]?.TotalOCCPercentage
                                                            ? item?.OnTheBook?.[0]?.TotalOCCPercentage
                                                            : 0}
                                                        %
                                                    </td>
                                                    <td
                                                        className="text-end perbackground perbackground-adr border_right"
                                                        value={item?.OnTheBook?.[0]?.ADR}
                                                    >
                                                        {item?.OnTheBook?.[0]?.ADR
                                                            ? commonService.formateAmount(
                                                                item?.OnTheBook?.[0]?.ADR
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>
                                                    <td className="text-end">
                                                        {item?.OnTheBook?.[0]?.REV
                                                            ? commonService.formateAmount(
                                                                item?.OnTheBook?.[0]?.REV
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>
                                                    <td className="text-end border_right">
                                                        {item?.OnTheBook?.[0]?.RevPAR
                                                            ? commonService.formateAmount(
                                                                item?.OnTheBook?.[0]?.RevPAR
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>
                                                    <td
                                                        className="perbackground perbackground-GroupOTB border_right text-center text-primary"
                                                        value={item?.OnTheBook?.[0]?.OTB}
                                                    >
                                                        <span id={commonService.generateGlobalClickTrackerID("LowDemandDates", "low-demand-dates-group-otb-block", item)}
                                                            className={`${selectedTdIndexRef.current === index &&
                                                                singleDateTypeRef.current === "lowDemand"
                                                                ? "singleDateSummarySpan"
                                                                : ""
                                                                }`}
                                                            onClick={(e) => {
                                                                singleDateTypeRef.current = "lowDemand";
                                                                singleDateSelectedDateRef.current =
                                                                    item?.StayDate;
                                                                handleOtbClick(e);
                                                                selectedTdIndexRef.current = index;
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            {item?.OnTheBook?.[0]?.OTB
                                                                ? commonService.formateRoom(
                                                                    item?.OnTheBook?.[0]?.OTB
                                                                )
                                                                : 0}
                                                            \
                                                            {item?.OnTheBook?.[0]?.Block
                                                                ? commonService.formateRoom(
                                                                    item?.OnTheBook?.[0]?.Block
                                                                )
                                                                : 0}
                                                        </span>
                                                    </td>
                                                    <td className="text-center">
                                                        {item?.Bar_Based_OTB
                                                            ? commonService.formateRoom(item?.Bar_Based_OTB)
                                                            : commonService.formateRoom(0)}
                                                    </td>
                                                    <td className="text-center border_right">
                                                        {item?.Bar_Based_8week_AVG
                                                            ? commonService.formateRoom(
                                                                item?.Bar_Based_8week_AVG
                                                            )
                                                            : commonService.formateRoom(0)}
                                                    </td>
                                                    <td
                                                        className="perbackground perbackground-1room text-center"
                                                        value={item?.["1 Day Pickup"]?.[0]?.RMS}
                                                    >
                                                        {item?.["1 Day Pickup"]?.[0]?.RMS
                                                            ? commonService.formateRoom(
                                                                item?.["1 Day Pickup"]?.[0]?.RMS
                                                            )
                                                            : 0}
                                                    </td>
                                                    <td className="text-end">
                                                        {item?.["1 Day Pickup"]?.[0]?.ADR
                                                            ? commonService.formateAmount(
                                                                item?.["1 Day Pickup"]?.[0]?.ADR
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>

                                                    <td className="text-end border_right">
                                                        {item?.["1 Day Pickup"]?.[0]?.ADR && item?.["1 Day Pickup"]?.[0]?.RMS
                                                            ? commonService.formateAmount(
                                                                parseFloat(item?.["1 Day Pickup"]?.[0]?.ADR) * parseFloat(item?.["1 Day Pickup"]?.[0]?.RMS)
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>
                                                    <td
                                                        className="perbackground perbackground-room text-center"
                                                        value={item?.["7 Day Pickup"]?.[0]?.RMS}
                                                    >
                                                        {item?.["7 Day Pickup"]?.[0]?.RMS
                                                            ? commonService.formateRoom(
                                                                item?.["7 Day Pickup"]?.[0]?.RMS
                                                            )
                                                            : commonService.formateRoom(0)}
                                                    </td>
                                                    <td className="text-end">
                                                        {item?.["7 Day Pickup"]?.[0]?.ADR
                                                            ? commonService.formateAmount(
                                                                item?.["7 Day Pickup"]?.[0]?.ADR
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>

                                                    <td className="text-end border_right">
                                                        {item?.["7 Day Pickup"]?.[0]?.ADR && item?.["7 Day Pickup"]?.[0]?.RMS
                                                            ? commonService.formateAmount(
                                                                parseFloat(item?.["7 Day Pickup"]?.[0]?.ADR) * parseFloat(item?.["7 Day Pickup"]?.[0]?.RMS)
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>

                                                    <td className="text-center">
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            <p
                                                                className={`${foreCastSpiderTextColor} ${forecastSpiderBorder} m-0`}
                                                                style={{ padding: "2px" }}
                                                            >
                                                                {item?.Forecast_RMS
                                                                    ? commonService.formateRoom(
                                                                        item?.Forecast_RMS
                                                                    )
                                                                    : commonService.formateRoom(0)}
                                                            </p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {item?.R28AVG
                                                            ? commonService.formateRoom(item?.R28AVG)
                                                            : commonService.formateRoom(0)}
                                                    </td>
                                                    <td className="text-end border_right">
                                                        {item?.Optimal_BAR
                                                            ? `${commonService.formateAmount(
                                                                item?.Optimal_BAR
                                                            )}`
                                                            : `${commonService.formateAmount(0)}`}
                                                    </td>
                                                    {item?.Rateshop && (
                                                        <td
                                                            className={`text-end ${isSelfData?.[0]?.Rate < avgCompetitor
                                                                ? "greenText"
                                                                : "redText"
                                                                }`}
                                                        >
                                                            {isSelfData?.length > 0
                                                                ? `${commonService.formateAmount(
                                                                    Math.round(isSelfData[0]?.Rate)
                                                                )}`
                                                                : `${commonService.formateAmount(0)}`}
                                                        </td>
                                                    )}
                                                    {item?.Rateshop && (
                                                        <td className="text-end">
                                                            {avgCompetitor
                                                                ? `${commonService.formateAmount(
                                                                    avgCompetitor
                                                                )}`
                                                                : `${commonService.formateAmount(0)}`}
                                                        </td>
                                                    )}

                                                    {item?.Rateshop?.map((x) => {
                                                        if (x.IsSelf === false) {
                                                            return (
                                                                <td className="text-end">
                                                                    {x?.Rate
                                                                        ? `${commonService.formateAmount(
                                                                            Math.round(x?.Rate)
                                                                        )}`
                                                                        : `${commonService.formateAmount(0)}`}
                                                                </td>
                                                            );
                                                        }
                                                    })}
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr className="text-center">
                                            <td colSpan={50}>No Data Found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </Col>
            </Row>
            {api !== 0 && <Comments widgetDetails={para} editorId={"LowDemandDates"} />}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}

            <Overlay
                show={ONTHEBOOKS.IsDisplay}
                target={ONTHEBOOKS.Target}
                placement={ONTHEBOOKS.Position}
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                    style={{ zIndex: 999999 }}
                >
                    <div className="horizontal-menu-option active">
                        <SingleDateSummaryModal
                            closeModal={closeSingleDate}
                            asOfDate={asOfDateFromRTK}
                            selectedDate={singleDateSelectedDateRef.current}
                            pickupDate={sevenDayPickupRef.current}
                            propertyDetail={{
                                propertyCode: propertyDetailFromRTK?.propertycode,
                            }}
                        />
                    </div>
                </Popover>
            </Overlay>
            <Overlay
                show={otbModal.IsDisplay}
                target={otbModal.Target}
                placement={otbModal.Position}
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                >
                    <div className="horizontal-menu-option active singleDayGroupSummary">
                        <SingleDayGroupModal
                            closeModal={closeOtbClick}
                            asOfDate={asOfDateFromRTK}
                            selectedDate={singleDateSelectedDateRef.current}
                            propertyCode={propertyDetailFromRTK?.propertycode}
                        />
                    </div>
                </Popover>
            </Overlay>
        </div>
    );
};


export default LowDemandDates;
